export default __webpack_public_path__ + "static/media/account.2cbc63db.svg";